module.exports = __webpack_public_path__ + "static/media/league.bda85445.png";